import { useJumboLayoutSidebar } from '@jumbo/hooks';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { Box, Card, Chip, Tooltip, Typography } from '@mui/material';
import { getLocaleDateWithTimeCustom } from 'app/utils/appHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentMeeting } from 'stores/meeting';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import AvatarListGroup from '../AvatarListGroup';


function DashboardReviewCard({ meeting }) {

    const userList = useSelector(state => state.user.data || []);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let users = meeting.users
    let mUsers = []

    users.forEach(element => {
        const user = userList.find(item => item.id === element);
        mUsers.push(user)
    });


    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

    const handleCardClick = () => {

        const updatedMeeting = {
            ...meeting,
            users: mUsers,
        };

        dispatch(setCurrentMeeting(updatedMeeting));
        navigate('/reviewPage');
        setSidebarOptions({ open: false })

    };

    const { dshReviewBackgroundcolor, dshReviewChip } = useTemplateFontSettings();

    return (
        <Card
            sx={{
                backgroundColor: dshReviewBackgroundcolor,
                minHeight: '140px',
                padding: '7px',
                overflow: 'hidden',
            }}
            onClick={() => handleCardClick()}
        >
            <Tooltip
                title="Değerlendirmek için dokunun lütfen"
                arrow
                style={{ color: "#424242", cursor: 'pointer' }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0, m: 0 }}>
                    {/* Header: Icon ve Chip */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: 0,
                            marginBottom: '5px'
                        }}
                    >
                        <ReviewsIcon style={{ color: "#3F88C5" }} />
                        <Chip
                            size="small"
                            label={`${meeting.decisionCount} Madde`}
                            sx={{
                                bgcolor: dshReviewChip,
                                padding: '0',
                                color: '#ffffff'
                            }}
                        />
                    </Box>
                    <Box sx={{ mt: 1, p: 0, m: 0 }}>


                        <Box
                            sx={{
                                height: '40px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    color: '#424242'
                                }}
                            >
                                {meeting.inst}  {meeting.unit}
                            </Typography>
                        </Box>

                        <hr style={{ margin: '2px 0' }} />
                        <Typography
                            sx={{ textAlign: 'left', color: '#424242' }}
                        >
                            Sayı: {meeting.meetingNo}
                        </Typography>
                        <Typography
                            sx={{ textAlign: 'left', color: '#424242' }}
                        >
                            Tarih: {getLocaleDateWithTimeCustom('tr', meeting.pdate)}
                        </Typography>
                        <Box sx={{ textAlign: 'left', p: 0, m: 0 }}>
                            <AvatarListGroup users={mUsers} />
                        </Box>
                    </Box>
                </Box>
            </Tooltip>
        </Card>
    );
}

export default DashboardReviewCard;